import { useState } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";

const PasswordInput = (props: any) => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  return (
    <div className="flex relative text-[#F2FAF7] ">
      <input
        type={passwordVisible ? "text" : "password"}
        placeholder="Create Password"
        className="p-4  border text-[#000] rounded-md flex-1 bg-[#F2FAF7] outline-[#0eb683]"
        required
        { ...props }
      />
      <span className="text-red-600 absolute top-3 left-2">*</span>
      <button
        className="inline-flex absolute top-[50%] right-5 -translate-y-1/2 text-[#5C6F7F]"
        onClick={() => setPasswordVisible(!passwordVisible)}
      >
        {passwordVisible ? <FiEye /> : <FiEyeOff />}
      </button>
    </div>
  );
};

export default PasswordInput;
